import DropdownComponent from './dropdown.component'

const DropdownModule = angular.module('cdbl.dropdown', [

])
  .component('cdblDropdown', DropdownComponent)
  .name

export default DropdownModule
